import { Segments } from '@/firebase/index';

export default {
  getAllSegments() {
    return Segments.get();
  }
};
